export default __webpack_public_path__ + "static/media/official-goopter-logo.d66221e4.png";